// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, chatHistoryListingClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetChatHistoryClientApi = createAsyncThunk(
  "hitGetChatHistoryClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + chatHistoryListingClient;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetChatHistoryClientSlice = createSlice({
  name: "getChatHistoryClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetChatHistoryClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetChatHistoryClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetChatHistoryClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetChatHistoryClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetChatHistoryClientData } = GetChatHistoryClientSlice.actions;
export default GetChatHistoryClientSlice.reducer;
